<template>
  <el-dialog
      width="1000px"
      :title="editType == 1 ? '新增' : '编辑'"
      :visible.sync="editShow"
      :before-close="close"
      @open="init"
  >
    <el-form :model="messageForm" ref="messageForm" :rules="rules" label-width="160px" label-position="right"
             size="small">
      <el-form-item label="标题" prop="title">
        <el-input v-model="messageForm.title" placeholder="请输入标题"></el-input>
      </el-form-item>

      <el-form-item label="描述" prop="description">
        <el-input v-model="messageForm.description" placeholder="请输入描述"></el-input>
      </el-form-item>

      <el-form-item label="图片" prop="coverUrl">
        <UploadFile
            ref="UploadFileRef"
            v-if="editShow"
            moduleName="partnerTask"
            accept=".png,.jpg,.jpeg"
            @upload-success="uploadSuccess"
            @upload-remove="uploadRemove"
            :limit="1"
            :hidenList="true"
            listType="picture"
        ></UploadFile>
      </el-form-item>

      <el-form-item label="置顶" prop="isTop">
        <el-switch v-model="messageForm.isTop" active-color="#144ED3" inactive-color="#DCDFE6"/>
      </el-form-item>

      <el-form-item label="排序" prop="sortOrder">
        <el-input-number v-model="messageForm.sortOrder" placeholder="请输入排序"></el-input-number>
      </el-form-item>

      <el-form-item label="内容" prop="content">
        <Editor v-model="messageForm.content" :min-height="200" :max-height="500"/>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submitForm">提 交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Editor from "@/components/Editor";
import {createPartnerTask, getPartnerTaskDetail, updatePartnerTask} from "@/api/partnerTask";

export default {
  props: ["editShow", "editType", "id"],
  components: {
    Editor
  },
  data() {
    return {
      messageForm: {
        title: "",
        content: "",
        description: "",
        sortOrder: "",
        msgType: 1,
        isTop: false,
        publishNow: false,
        coverUrl: ""
      },
      rules: {
        title: [{required: true, message: "请输入标题", trigger: "blur"}],
        content: [{required: true, message: "请输入内容", trigger: "blur"}],
        coverUrl: [{required: true, message: "请上传图片", trigger: "change"}],
        sortOrder: [{required: true, message: "请输入排序", trigger: "blur"}],
      },
    };
  },

  methods: {
    uploadRemove(file, fileList) {
      this.messageForm.coverUrl = ""
    },
    uploadSuccess(res, fileList) {
      this.messageForm.coverUrl = res.data.fileUrl
    },
    init() {
      this.messageForm = {
        title: "",
        content: "",
        description: "",
        sortOrder: "",
        msgType: 1,
        isTop: false,
        publishNow: false,
        coverUrl: ""
      }
      if (this.editType == 2) {
        this.getDetail();
      }
    },

    async getDetail() {
      try {
        let res = await getPartnerTaskDetail({id: this.id});
        if (res.code == 200) {
          this.messageForm = res.data || {};
          this.$refs.UploadFileRef.pushFile(res.data.coverUrl)
        }
      } catch (error) {
        console.log(error);
      }
    },

    close() {
      this.$refs["messageForm"].resetFields();
      this.$emit("close");
    },

    submitForm() {
      this.$refs["messageForm"].validate(valid => {
        if (valid) {
          if (this.editType == 1) {
            this.createMessage();
          } else if (this.editType == 2) {
            this.updateMessage();
          }
        } else {
          return false;
        }
      });
    },

    async createMessage() {
      try {
        this.messageForm.id = null;
        let res = await createPartnerTask(this.messageForm);
        if (res.code == 200) {
          this.$message({
            message: "新增成功",
            type: "success"
          });
          this.close();
        }
      } catch (error) {
        console.log(error);
      }
    },

    // 编辑配置
    async updateMessage() {
      try {
        let res = await updatePartnerTask(this.messageForm);
        if (res.code == 200) {
          this.$message({
            message: "编辑成功",
            type: "success"
          });
          this.close();
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.w300 {
  width: 300px;
}

.el-select {
  width: 300px;
}

.dialog-footer {
  text-align: center;
}

#json-editor-container {
  width: 100%;
  min-height: 200px;
  max-height: 500px;
  padding: 10px 10px 10px 0;
  border: 1px solid #e4e7ed;
  border-radius: 5px;
}
</style>
